import StampImageLink from '../../stamp-image-link/stamp-image-link'
import getNumberOfLabelsInFlood from '../../../helpers/fields-calculation/stamps/get-number-of-labels-in-flood'
import getMaxWidthOfMaterial from '../../../helpers/fields-calculation/stamps/get-max-width-of-material'
import Stamp from '../../../types/api/stamp'
import renderDate from '../../../helpers/tables/render-date'
import { ColumnType } from 'antd/es/table'
import { StrapiDataItem } from '../../../types/strapi/strapi'
import SelectButton from './components/select-button'
import { formatRollerDisplay } from '../../../helpers/format-roller-display'

export const columns: ColumnType<StrapiDataItem<Stamp>>[] = [
    {
        dataIndex: 'imageLink',
        title: 'Макет',
        render(_value, record) {
            return <StampImageLink stamp={record} />
        },
    },
    {
        dataIndex: 'number',
        title: 'Номер',
    },
    {
        dataIndex: 'width',
        title: 'Ширина',
        sorter: (a, b) => a.width - b.width,
    },
    {
        dataIndex: 'length',
        title: 'Длина',
        sorter: (a, b) => a.length - b.length,
    },
    {
        dataIndex: 'floods',
        title: 'Ручьи (max)',
    },
    {
        dataIndex: ['roller', 'roller'],
        title: 'Раппорт',
        render: (v: number) => formatRollerDisplay(v),
    },
    {
        dataIndex: 'range',
        title: 'Раст. меж. этикеток',
    },
    {
        dataIndex: 'materialMaxWidth',
        title: 'Ширина материала (max)',
        render: (v, r: Stamp) => getMaxWidthOfMaterial(r),
    },
    {
        dataIndex: 'shape',
        title: 'Форма',
    },
    {
        dataIndex: 'remark',
        title: 'Примечание',
    },
    {
        dataIndex: 'numberOfLabelsIfFlood',
        title: 'Кол-во в 1 ручье',
        // @ts-ignore
        render: (v, r: Stamp) =>
            getNumberOfLabelsInFlood({
                roller: r.roller?.roller,
                range: r.range,
                length: r.length,
            }),
    },
    {
        dataIndex: 'material_types',
        title: 'Материал',
        render() {
            return 'Пленка PP'
        },
    },
    {
        dataIndex: ['last_order', 'orderStatus'],
        title: 'Статус',
    },
    {
        dataIndex: ['last_order', 'endDate'],
        title: 'Дата',
        render: v => (v ? renderDate(v) : ''),
    },
    {
        dataIndex: 'actions',
        title: '',
        render(v, r) {
            return <SelectButton row={r} />
        },
    },
]
